// Utilities
import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'
import { HmacMD5 } from '@/lib/crypto/crypto.js'
import encryptSerializer from '@/stores/encryptSerializer.js'

const pinia = createPinia()

const persistedStateDebug = import.meta.env.VITE_PERSISTED_STATE_DEBGUG === 'true'
const persistedStateEncryptedKeys = import.meta.env.VITE_PERSISTED_STATE_ENCRYPTED_KEYS === 'true'
const persistedStateEncryptedValues = import.meta.env.VITE_PERSISTED_STATE_ENCRYPTED_VALUES === 'true'
const persistedStatePrefix = import.meta.env.VITE_PERSISTED_STATE_PREFIX ?? ''
const persistedStateSeparator = import.meta.env.VITE_PERSISTED_STATE_SEPARATOR ?? '-'
const finalPrefix = persistedStatePrefix ? (persistedStatePrefix + persistedStateSeparator + 'store' + persistedStateSeparator) : ('store' + persistedStateSeparator)

pinia.use(createPersistedState({
  key    : objId => persistedStateEncryptedKeys ? HmacMD5.hash(`${finalPrefix}${objId}`) : `${finalPrefix}${objId}`,
  storage: sessionStorage, // sessionStorage || localStorage
  ...(persistedStateEncryptedValues && { serializer: encryptSerializer }),
  debug  : persistedStateDebug
}))

export default pinia
